import { UserTableConstructorInfo } from 'src/app/interfaces/tables.interfaces';
import { SuggestedUser } from '../relation-request.interface';

export abstract class UserSearchTableConstructor {
  public abstract buildTableData(items: SuggestedUser[]): UserTableConstructorInfo;
}
